module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('beginExercise', {
    attrs: {
      "CelotnaNaloga": _vm.exerciseVersion
    }
  }), _vm._v(" "), _vm._l((_vm.exerciseVersion.questions), function(uprasanje, index) {
    return [_c('div', {
      key: index
    }, [(uprasanje.type.toLowerCase() == 'numerical') ? _c('numeric', {
      key: uprasanje.guid,
      attrs: {
        "uniqueKey": _vm.nameOfQuestion + _vm.getUniqueKey(),
        "CelotnoVprasanje": uprasanje,
        "exerciseVersionId": _vm.exerciseVersion.exerciseVersionId,
        "scoringSettings": _vm.exerciseVersion.scoringSettings,
        "showAnswer": _vm.showAnswer,
        "identifier": _vm.getIdentifier(),
        "parent": _vm.exerciseVersion.parent,
        "index": index
      }
    }) : _vm._e(), _vm._v(" "), (uprasanje.type.toLowerCase() == 'radio') ? _c('radio', {
      key: uprasanje.guid,
      attrs: {
        "uniqueKey": _vm.nameOfQuestion + _vm.getUniqueKey(),
        "CelotnoVprasanje": uprasanje,
        "exerciseVersionId": _vm.exerciseVersion.exerciseVersionId,
        "scoringSettings": _vm.exerciseVersion.scoringSettings,
        "showAnswer": _vm.showAnswer,
        "identifier": _vm.getIdentifier(),
        "parent": _vm.exerciseVersion.parent,
        "index": index
      }
    }) : _vm._e(), _vm._v(" "), (uprasanje.type.toLowerCase() == 'essay') ? _c('essay', {
      key: uprasanje.guid,
      attrs: {
        "uniqueKey": _vm.nameOfQuestion + _vm.getUniqueKey(),
        "CelotnoVprasanje": uprasanje,
        "exerciseVersionId": _vm.exerciseVersion.exerciseVersionId,
        "scoringSettings": _vm.exerciseVersion.scoringSettings,
        "showAnswer": _vm.showAnswer,
        "identifier": _vm.getIdentifier(),
        "parent": _vm.exerciseVersion.parent,
        "index": index
      }
    }) : _vm._e(), _vm._v(" "), (uprasanje.type.toLowerCase() == 'multichoice') ? _c('multichoice', {
      key: uprasanje.guid,
      attrs: {
        "uniqueKey": _vm.nameOfQuestion + _vm.getUniqueKey(),
        "CelotnoVprasanje": uprasanje,
        "exerciseVersionId": _vm.exerciseVersion.exerciseVersionId,
        "scoringSettings": _vm.exerciseVersion.scoringSettings,
        "showAnswer": _vm.showAnswer,
        "identifier": _vm.getIdentifier(),
        "parent": _vm.exerciseVersion.parent,
        "index": index
      }
    }) : _vm._e(), _vm._v(" "), (uprasanje.type.toLowerCase() == 'slider') ? _c('slider', {
      key: uprasanje.guid,
      attrs: {
        "uniqueKey": _vm.nameOfQuestion + _vm.getUniqueKey(),
        "CelotnoVprasanje": uprasanje,
        "exerciseVersionId": _vm.exerciseVersion.exerciseVersionId,
        "scoringSettings": _vm.exerciseVersion.scoringSettings,
        "showAnswer": _vm.showAnswer,
        "identifier": _vm.getIdentifier(),
        "parent": _vm.exerciseVersion.parent,
        "index": index
      }
    }) : _vm._e(), _vm._v(" "), (uprasanje.type.toLowerCase() == 'crypto') ? _c('crypto', {
      key: uprasanje.guid,
      attrs: {
        "uniqueKey": _vm.nameOfQuestion + _vm.getUniqueKey(),
        "CelotnoVprasanje": uprasanje,
        "exerciseVersionId": _vm.exerciseVersion.exerciseVersionId,
        "scoringSettings": _vm.exerciseVersion.scoringSettings,
        "showAnswer": _vm.showAnswer,
        "identifier": _vm.getIdentifier(),
        "parent": _vm.exerciseVersion.parent,
        "index": index
      }
    }) : _vm._e()], 1)]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43a34de4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a34de4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/Exercise.vue
// module id = 1433
// module chunks = 1